import React from 'react'
import LinksMatchesScreen from './LinksMatchesScreen';

function RecentlyViewed() {

    const links = [
        { name: "Recently Viewed Members", to: "/recently-viewed/recent" },
        { name: "Contact Viewed", to: "/recently-viewed/contact-viewed" },
        { name: "Shortlisted Members", to: "/recently-viewed/shortlisted" },
        { name: "Ignored Members", to: "/recently-viewed/ignored" },
        { name: "Blocked Members", to: "/recently-viewed/blocked" },
        { name: "Your Profile Visitors", to: "/recently-viewed/recent-visitors" },
    ]

    return (
        <LinksMatchesScreen links={links} />
    )
}

export default RecentlyViewed